import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import { Scrollbars } from 'react-custom-scrollbars';

import withProfile from 'hocs/withProfile';

import fullname from 'utils/fullname';

import ChatRoomOpenHeader from 'chats/ChatRoomOpenHeader';
import ChatRoomOpenBodyContainer from 'chats/ChatRoomOpenBodyContainer';
import ChatRoom from 'chats/ChatRoom';
import Tab from 'components/Tab';
import Loader from 'components/Loader';
import SecondaryButton from 'styled/Buttons/SecondaryButton';

import TabsWrapper from './TabsWrapper';
import ChatsStyled from './ChatsStyled';
import ChatRoomsListContainer from './ChatRoomsListContainer';
import ChatRoomOpenWrapper from './ChatRoomOpenWrapper';

const TABS = [{
  label: 'Чаты техподдержки',
  filter: 'tech_chat',
}, {
  label: 'Чаты с пользователями',
  filter: 'moderator_chat',
}];

export class Chats extends React.PureComponent {
  render() {
    return (
      <ChatsStyled>
        <TabsWrapper>
          {TABS.map(tab => (
            <Tab
              style={{ margin: '0' }}
              key={tab.label}
              tab={tab}
              active={tab.filter === this.props.roomType}
              onChange={this.props.onTabChange}
            />
          ))}
        </TabsWrapper>

        <ChatRoomsListContainer>
          <Scrollbars>
            {this.props.chatRooms.map(chatRoom => (
              <ChatRoom
                key={chatRoom.id}
                id={chatRoom.id}

                username={fullname(chatRoom.user)}
                avatarUrl={chatRoom.user && chatRoom.user.avatar && chatRoom.user.avatar.url}
                lastMessage={chatRoom.lastMessage && chatRoom.lastMessage.text}
                lastMessageAt={chatRoom.lastMessage && chatRoom.lastMessage.createdAt * 1000}
                hasNewMessages={chatRoom.hasNewMessages}

                active={this.props.activeChatRoom && this.props.activeChatRoom.id === chatRoom.id}
                isChatRoomOpen={Boolean(this.props.activeChatRoom)}

                onSelect={this.props.onChatRoomSelect}
              />
            ))}

            {this.props.errors.length > 0 && (
              <div style={{ padding: '40px', textAlign: 'center' }}>
                {this.props.errors.map(message => (
                  <p key={message} role="alert">{message}</p>
                ))}

                <SecondaryButton type="button" onClick={this.props.onReloadClick}>Обновить</SecondaryButton>
              </div>
            )}

            {!this.props.loading && !this.props.errors.length && this.props.chatRooms.length === 0 && (
              <div style={{ padding: '40px', textAlign: 'center' }}>
                <p role="alert">Пока нет ни одной чат-комнаты</p>

                <SecondaryButton type="button" onClick={this.props.onReloadClick}>Обновить</SecondaryButton>
              </div>
            )}

            {this.props.loading && <Loader />}

            {!this.props.loading && !this.props.errors.length && this.props.next && (
              <Waypoint onEnter={this.props.onWaypointEnter} />
            )}
          </Scrollbars>

          {this.props.activeChatRoom && (
            <ChatRoomOpenWrapper>
              <ChatRoomOpenHeader
                id={this.props.activeChatRoom.id}

                canFinish={
                  this.props.activeChatRoom.roomType === 'moderator_chat' &&
                  this.props.activeChatRoom.locked &&
                  this.props.activeChatRoom.lockedEmployeeId === this.props.profile.id
                }

                userId={this.props.activeChatRoom.user && this.props.activeChatRoom.user.id}
                fullname={fullname(this.props.activeChatRoom.user)}
                avatarUrl={this.props.activeChatRoom.user && this.props.activeChatRoom.user.avatar && this.props.activeChatRoom.user.avatar.url}
                isBanned={this.props.activeChatRoom.user && Boolean(this.props.activeChatRoom.user.currentBan)}
                socialLinks={this.props.activeChatRoom.user && this.props.activeChatRoom.user.oauthProviders}

                onClose={this.props.onChatRoomOpenClose}
                onChatRoomFinished={this.props.onChatRoomFinished}
                onBan={this.props.onBan}
              />

              <ChatRoomOpenBodyContainer
                id={this.props.activeChatRoom.id}

                startChatAutoFocus
                hasNewMessages={this.props.activeChatRoom.hasNewMessages}
                roomType={this.props.activeChatRoom.roomType}
                locked={this.props.activeChatRoom.locked}
                lockedEmployeeId={this.props.activeChatRoom.lockedEmployeeId}
                lockedEmployeeFullname={this.props.activeChatRoom.lockedEmployeeFullname}
                userId={this.props.activeChatRoom.user && this.props.activeChatRoom.user.id}

                onChatRoomStarted={this.props.onChatRoomStarted}
                onChatRoomFinished={this.props.onChatRoomFinished}
                onMessageSended={this.props.onMessageSended}
                onChatRoomRead={this.props.onChatRoomRead}

                socket={this.props.socket}
              />
            </ChatRoomOpenWrapper>
          )}
        </ChatRoomsListContainer>
      </ChatsStyled>
    );
  }
}

Chats.propTypes = {
  chatRooms: PropTypes.arrayOf(PropTypes.shape({})),
  errors: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
  next: PropTypes.bool,

  // TODO: сделать плоско
  activeChatRoom: PropTypes.shape({
    id: PropTypes.string,
    hasNewMessages: PropTypes.bool,
    roomType: PropTypes.string,
    locked: PropTypes.bool,
    lockedEmployeeId: PropTypes.string,
    lockedEmployeeFullname: PropTypes.string,
    user: PropTypes.shape({
      id: PropTypes.string,
      avatar: PropTypes.shape({ url: PropTypes.string }),
      currentBan: PropTypes.shape(),
      oauthProviders: PropTypes.arrayOf(PropTypes.shape({
        provider: PropTypes.oneOf(['vkontakte', 'odnoklassniki', 'facebook', 'twitter', 'instagram', 'google']),
        socialLink: PropTypes.string,
      })),
    }),
  }),

  roomType: PropTypes.oneOf(['moderator_chat', 'tech_chat']),

  onWaypointEnter: PropTypes.func,
  onReloadClick: PropTypes.func,
  onTabChange: PropTypes.func,
  onChatRoomSelect: PropTypes.func,
  onChatRoomOpenClose: PropTypes.func,
  onChatRoomStarted: PropTypes.func,
  onChatRoomFinished: PropTypes.func,
  onBan: PropTypes.func,
  onMessageSended: PropTypes.func,
  onChatRoomRead: PropTypes.func,

  socket: PropTypes.shape({}),

  profile: PropTypes.shape({ id: PropTypes.string }),
};

Chats.defaultProps = {
  chatRooms: [],
  errors: [],
  loading: true,
  next: false,

  activeChatRoom: undefined,
  roomType: 'tech_chat',

  onWaypointEnter: () => {},
  onReloadClick: () => {},
  onTabChange: () => {},
  onChatRoomSelect: () => {},
  onChatRoomOpenClose: () => {},
  onChatRoomStarted: () => {},
  onChatRoomFinished: () => {},
  onBan: () => {},
  onMessageSended: () => {},
  onChatRoomRead: () => {},

  socket: undefined,

  profile: {},
};

export default withProfile(Chats);
